//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';

//#endregion

//-----------------------------------------------------------------
export function DeleteBatchDialog( { is_open, onConfirm, onClose } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
    }
  }

  const CONTAINER = {
    sx              : _styles.container,
    open            : is_open,
    onClose         : onClose,
    ariaLabelledby  : 'alert-dialog-title',
    ariaDescribedby : 'alert-dialog-description',
  }

  const CONFIRM = {
    color     : 'primary'     ,
    onClick   : onConfirm     ,
    autoFocus : true          ,
    children  : [ 'Confirm' ] ,
  }

  const CANCEL = {
    color     : 'primary'   ,
    onClick   : onClose     ,
    autoFocus : true        ,
    children  : [ 'Cancel' ] ,
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Dialog { ...CONTAINER } >
        <DialogTitle id='alert-dialog-title'>{'Confirm Batch Deletion'}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to delete the selected batch(es)?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button { ...CANCEL   } />
          <Button { ...CONFIRM } />
        </DialogActions>
      </Dialog>
    )
  }

  //#endregion

  return display();
}